import { ButtonAuthenticationPrimary } from "@nova/component-btn"
import { useCallback, useState } from "react"
import { useTranslation } from "tools/translations"
import CompactAuthenticationManagementForm from "./CompactAuthenticationManagementForm"
import { AuthenticationInput } from "./inputs/AuthenticationInput"
import * as Icons from "@nova/component-icons"
import { useAppSelector } from "integrations/redux/hooks"
import { selectAuthenticationErrorMessage } from "user/authentication/selectors"
import { AuthenticationErrorMessage } from "./AuthenticationErrorMessage"

type TriggerPasswordResetForm = {
    email?: string
    primaryClickHandler: (email: string) => void
    isLoading?: boolean
}

export default function TriggerPasswordResetForm({
    email: defaultEmail,
    primaryClickHandler,
    isLoading = false,
}: TriggerPasswordResetForm) {
    const { t } = useTranslation()
    const authenticationError = useAppSelector(selectAuthenticationErrorMessage)
    const [email, setEmail] = useState(defaultEmail)

    const submitHandler = useCallback(
        async (values: { email?: string }) => {
            const { email } = values

            if (!email) {
                throw "Cannot initialize password reset flow without an email"
            }

            primaryClickHandler(email)
        },
        [primaryClickHandler]
    )

    return (
        <CompactAuthenticationManagementForm submitHandler={submitHandler}>
            <AuthenticationInput
                id="email"
                name="email"
                label="Email*"
                type="email"
                defaultValue={defaultEmail}
                disabled={isLoading}
                onChange={(e) => setEmail(e.target.value)}
                leftIcon={Icons.Email}
            />
            {authenticationError && <AuthenticationErrorMessage message={authenticationError} />}
            <ButtonAuthenticationPrimary
                disabled={isLoading || !email}
                className="authentication-management-button"
                title={t("authenticate:send-code")}
                isLoading={isLoading}
            />
        </CompactAuthenticationManagementForm>
    )
}
